// const Vue = require('vue');
import Vue from 'vue';
import '@/assets/icon/iconfont.css'
let tim
if(process.client) {
  
  const TIM = require('tim-js-sdk')
  const COSSDK = require ('cos-js-sdk-v5')
  const defaultSettings = require('./settings')

  tim = TIM.create({
    SDKAppID: defaultSettings.TimSDKAppID
  })
  tim.registerPlugin({'cos-js-sdk':COSSDK})
  // window.TIM = TIM
  Vue.prototype.tim = tim
  Vue.prototype.TIM = TIM
  Vue.prototype.$bus = new Vue()
}
export default tim;
// const TIM = require('tim-js-sdk')


// import defaultSettings from ''

// 初始化 SDK 实例


// 注册 cos
// tim.registerPlugin({'cos-js-sdk':COSSDK})
